
export enum HOSAnnotationActionTypes {
    SET_ANNOTATIONS = "SET_ANNOTATIONS",
    CLEAR_ANNOTATIONS = "CLEAR_ANNOTATIONS"
}